<template>
  <layout-vendor-dashboard-inner
    :vendor-id="vendorId"
    :back-link="{ name: 'company-vendorId-dashboard', params: { vendorId } }">
    <orders-view :override-list-configuration="listConfiguration" />
  </layout-vendor-dashboard-inner>
</template>

<script>
import asyncOperations from "@/client/extensions/composition/asyncOperations";
import OrdersView from "@/client/applications/justopp/views/Orders";

export default {
  name: "Orders",
  components: { OrdersView },
  layout: {
    component: "noContainer",
    params: {
      title: "justopp.bids.pageTitle",
      subTitle: "justopp.bids.pageSubtitle",
      containerClass: "margin-remove-vertical",
    },
  },
  middleware: {
    requireVendorOrAdmin: { vendorIdFromParam: "vendorId" },
  },
  props: {
    // vendor ID
    vendorId: {
      type: String,
      default: 0,
    },
  },
  setup(props) {
    let { asyncOps, asyncOpsReady, asyncStatus } = asyncOperations(props);
    return { asyncOps, asyncOpsReady, asyncStatus };
  },
  data: function () {
    return {
      listConfiguration: {
        constantFilters: {
          vendorId: this.vendorId,
        },
      },
    };
  },
};
</script>

<style lang="scss" scoped></style>
